export function distinctGroupByField(array, field) {
  const arrayFiltered = [...new Set(array.map((x) => x[field]))];

  return arrayFiltered.map((el) => {
    return { name: el };
  });
}
